import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, Input, OnDestroy, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ConfirmationService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { TableModule } from 'primeng/table';
import { CustomTableReport } from 'src/app/interfaces/custom-table-report/custom-table-report.interface';

@Component({
  selector: 'app-custom-table-report-generated-receipts',
  templateUrl: './custom-table-report-generated-receipts.component.html',
  styleUrls: ['./custom-table-report-generated-receipts.component.scss'],
  standalone: true,
  imports: [CommonModule, ButtonModule, TableModule, DropdownModule, FormsModule],
  providers: [ConfirmationService]
})
export class CustomTableReportGeneratedReceiptsComponent implements AfterViewInit, OnDestroy {

  @ViewChild('headerContainer') headerContainer!: ElementRef;

  @Input() dataReport: CustomTableReport;
  @Input() filtersHeight: number = 0;

  resizeObserver?: ResizeObserver;
  scrollHeight: string = '0px';

  constructor(private cdr: ChangeDetectorRef) { }

  ngAfterViewInit() {
    this.initResizeObserver();
  }

  @HostListener('window:resize')
  onResize() {
    this.updateScrollHeight();
  }

  ngOnDestroy() {
    this.resizeObserver?.disconnect();
  }

  get data() {
    return this.dataReport?.data?.[0] ?? null;
  }

  get receipts(): any[] {
    return this.data?.items ?? [];
  }

  private initResizeObserver() {
    if (this.headerContainer?.nativeElement) {
      this.resizeObserver = new ResizeObserver(() => {
        this.updateScrollHeight();
      });
      this.resizeObserver.observe(this.headerContainer.nativeElement);
    }
  }

  private updateScrollHeight() {
    const headerHeight = this.headerContainer?.nativeElement?.offsetHeight || 0;
    this.scrollHeight = `${window.innerHeight - headerHeight - this.filtersHeight - 65}px`;
    this.cdr.detectChanges();
  }

}
